import { palette } from '../../../styles/tokens';
import type { SettingsCardConfig } from '../config/settingsConfig';
import type { CompletionStatus } from '../hooks/useSettingsCompletion';
import { SettingsCard } from './SettingsCard';

interface SettingsSectionProps {
  label: string;
  cards: SettingsCardConfig[];
  completionAreas: Record<string, CompletionStatus>;
}

export function SettingsSection({ label, cards, completionAreas }: SettingsSectionProps) {
  if (cards.length === 0) return null;

  return (
    <div style={{ marginBottom: 28 }}>
      <div style={{
        fontSize: 13,
        fontWeight: 600,
        color: palette.g500,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.04em',
        marginBottom: 12,
      }}>
        {label}
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 12,
      }}>
        {cards.map(card => {
          const status = card.completionKey === 'optional'
            ? 'optional' as CompletionStatus
            : completionAreas[card.completionKey];
          return (
            <SettingsCard
              key={card.id}
              config={card}
              status={status}
            />
          );
        })}
      </div>
    </div>
  );
}
